export default __webpack_public_path__ + "static/media/012-suitcase.953ca79d.svg";